export default {
  title: 'Aggiungi carta',
  buttons: {
    save: 'Salva',
  },
  feedback: {
    success: 'Carta salvata con successo',
  },
};
